"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const react_1 = __importDefault(require("react"));
const react_2 = require("@chakra-ui/react");
const colors = {
    white: '#FFFFFF',
    disabled: '#C0BEB9',
    prominent: {
        lightest: '#EAF5FF',
        light: '#D9EDFF',
        normal: '#006CCF',
        dark: '#024D95',
        darkest: '#15325D',
    },
    neutral: {
        lightest: '#F2F1EC',
        light: '#E7E5DF',
        normal: '#4F4E4C',
        dark: '#333231',
        darkest: '#242423',
    },
    negative: {
        lightest: '#FFEDE6',
        light: '#FFDED2',
        normal: '#C04226',
        dark: '#88311E',
        darkest: '#562317',
    },
};
const getStyleByIntent = ({ intent }) => ({
    solid: {
        borderColor: colors[intent].normal,
        borderWidth: 1,
        bgColor: colors[intent].normal,
        color: colors.white,
        _hover: {
            borderColor: colors[intent].dark,
            bgColor: colors[intent].dark,
        },
        _active: {
            borderColor: colors[intent].darkest,
            bgColor: colors[intent].darkest,
        },
    },
    outline: {
        bgColor: 'transparent',
        borderColor: colors[intent].normal,
        borderWidth: 1,
        color: colors[intent].normal,
        _hover: {
            bgColor: colors[intent].lightest,
            borderColor: colors[intent].dark,
            color: colors[intent].dark,
        },
        _active: {
            bgColor: colors[intent].light,
            borderColor: colors[intent].darkest,
            color: colors[intent].dark,
        },
    },
    ghost: {
        borderColor: 'transparent',
        borderWidth: 1,
        bgColor: 'transparent',
        color: colors[intent].normal,
        _hover: {
            bgColor: colors[intent].lightest,
            color: colors[intent].dark,
        },
        _active: {
            bgColor: colors[intent].light,
            color: colors[intent].darkest,
        },
    },
});
const UiKitButtonV2Styles = {
    prominent: getStyleByIntent({ intent: 'prominent' }),
    neutral: getStyleByIntent({ intent: 'neutral' }),
    negative: getStyleByIntent({ intent: 'negative' }),
};
const UiKitButtonDisabledStyles = {
    solid: {
        borderColor: colors.neutral.light,
        borderWidth: 1,
        bgColor: colors.neutral.light,
        color: colors.disabled,
        _hover: {},
        _active: {},
    },
    outline: {
        bgColor: 'transparent',
        color: colors.disabled,
        borderColor: colors.disabled,
        borderWidth: 1,
        _hover: {},
        _active: {},
    },
    ghost: {
        borderColor: 'transparent',
        borderWidth: 1,
        bgColor: 'transparent',
        color: colors.disabled,
        _hover: {},
        _active: {},
    },
};
const UiKitButtonV2SizeStyles = {
    xs: {
        fontSize: 12,
        fontWeight: 500,
        py: '0px',
        px: '4px',
    },
    sm: {
        fontSize: 12,
        fontWeight: 500,
        py: '4px',
        px: '8px',
    },
    md: {
        fontSize: 14,
        fontWeight: 500,
        py: '8px',
        px: '12px',
    },
};
const Button = ({ children, buttonAppearance = 'solid', intent = 'prominent', size = 'md', isDisabled = false, ...props }) => {
    return (react_1.default.createElement(react_2.Button, { borderRadius: 'full', size: size, isDisabled: isDisabled, transition: '250ms ease-in-out', ...(isDisabled
            ? UiKitButtonDisabledStyles[buttonAppearance]
            : UiKitButtonV2Styles[intent][buttonAppearance]), ...UiKitButtonV2SizeStyles[size], ...props }, children));
};
exports.Button = Button;
